import request from '@/utils/request'

export function add(data) {
  return request({
    url: 'api/users',
    method: 'post',
    data
  })
}

export function del(id) {
  return request({
    url: 'api/users/' + id,
    method: 'delete'
  })
}

export function edit(data) {
  return request({
    url: 'api/users',
    method: 'put',
    data
  })
}


export function saveUserSubejct(data) {
  return request({
    url: 'api/user/setUserSubject',
    method: 'post',
    data
  })
}

/**
 * 获取当前用户的详细信息
 */
export function getUserInfo(){
 return request({
  url: 'auth/info',
  method: 'get',

 });

}

export function updatePass(user) {
  const data = {
    oldPass: user.oldPass,
    newPass: user.newPass
  }
  return request({
    url: 'api/users/updatePass/',
    method: 'post',
    data
  })
}

export function updateEmail(code, data) {
  return request({
    url: 'api/users/updateEmail/' + code,
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/user.js